'use strict';

import React, { Component, useDebugValue } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import Select from 'react-select';
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';
import ColumnGroup from './columngroupComponent';
import { getDDMMYYYY, getHyphenYYYYMMDD,getHyphenDDMMMYYYYHHMM,getHyphenDDMMMYYYY,getHyphenYYYYMMDDHHMMSS,getHyphenDDMMYYYYHHMMSS,getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils';
import { Calendar as CalendarIcon, X as XIcon, ArrowRight as ArrowRightIcon } from 'lucide-react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import SobRunLogTab from './sobRunLogTab';
// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent="";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;
// Default the activity log to the current month - broad enough to be useful
// on first load, narrow enough not to reintroduce "loads everything" slowness
// (an unfiltered view still caps at pageLimit, but a date range never does -
// see loadActivities).
var getCurrentMonthRange = function() {
    return {
        from: moment().startOf('month').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
    };
};




export default class LmUserActivities extends Component {
  constructor(props) {
    super(props);
      this.state = {
        modules : AllModules,
        defaultColDef: {
            sortable: true,
            filter: true,
            editable: true,
        },
        eventAction: null,
        show: false,
        frameworkComponents : {
          
        },
        modified_by:"",
        basicTitle:'',
        reasonforceclose:"",
        bulkslide:"",
        file:"",
        uploadFile:"",
        basicType:"default",
        loadshow:'show-n',
        forceCloseRowNode : "",
        forceclosedata:"",
        csvcontent:"",
        sliderForceCloseTranslate:"",
        overly:'',
        rowData:[],
        // The backend pages through useractivities instead of returning the
        // whole (unboundedly-growing) collection - pageLimit is the default
        // cap with no date filter applied; applying From/To drops that cap
        // entirely (see loadActivities) since a date-bounded range is already
        // narrow by definition. The grid itself shows everything fetched in
        // one scrollable list - no separate client-side paging on top of that.
        pageLimit: 100,
        totalCount: 0,
        fromDateFilter: getCurrentMonthRange().from,
        toDateFilter: getCurrentMonthRange().to,
        // "activities" = the user activity log, "sob" = SOB Runs (run log + vehicle availability)
        activeTab: "activities",
        sobReloadKey: 0,
        bulkslide:"",
        showDiv:"",
        uploadDivWidth:"",
        mapinfo:"",
        dealer:"",
        sliderCommentTranslate:"",
        commentsRowData:"",
        consignment_code:"",
        sliderRouteTranslate:"",
        maptruckno:"",
        routeTruck:	"",
        rownode:"",
        googelRoutes:"",
        file:"",
        rowSelection:'multiple',
        sliderForceCloseTranslate:"",
        maptruckno:"",
        rowModelhighchartoptionsType: 'enterprise',
        rowGroupPanelShow: 'always',
            statusBar: {
        statusPanels: [
          {
          statusPanel: "agTotalAndFilteredRowCountComponent",
          align: "left"
          },
          {
          statusPanel: "agTotalRowCountComponent",
          align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
        ]
            },
        geofencelist:[],
        geoFenceData:"",
        sideBar: {
          toolPanels: [
            {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel"
            },
            {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel"
            }
          ]
        },
        animateRows: true,
        dept_code:"",
        pagetitle:"",
        markDeliverRowNode : "",
        markDeliverData:"",
        sliderMarkDeliverTranslate:"",
        csvData:0,
        overly:"show-m",
        loadshow:"show-m",
        showUserType:"show-m",
        plants:[],
        plant_name:"",
        cellPlants:[],
        sliderTranslate:'',
        //components : {datepicker:getDatePicker()}
    }
    this.gridRef = React.createRef();
  }

componentDidMount(){
    loadDateTimeScript();
    this.loadActivities();
}

// Single bounded fetch, no "Load More" clicking - narrowing the result set is
// the date filter's job. pageLimit is only a fallback for the (now unusual)
// case of no date filter at all - the backend itself drops any cap entirely
// once from_date/to_date is present, returning every matching record for the
// selected timeframe.
loadActivities = () => {
    this.setState({ loadshow: 'show-m', overly: 'show-m' });
    var params = {
        page: 1,
        limit: this.state.pageLimit,
    };
    if (this.state.fromDateFilter) params.from_date = this.state.fromDateFilter;
    if (this.state.toDateFilter) params.to_date = this.state.toDateFilter;
    redirectURL.post("/lmconsignees/getLmUserActivities", params)
    .then((response) => {
        var data = response.data || {};
        this.setState({
            rowData: data.records || [],
            totalCount: data.totalCount || 0,
            loadshow: 'show-n',
            overly: 'show-n',
        })
    })
    .catch(function(e){
        console.log("Error ",e)
    })
}

onApplyDateFilter = () => {
    if (this.state.activeTab === "sob") { this.setState({ sobReloadKey: this.state.sobReloadKey + 1 }); return; }
    this.loadActivities();
}

onClearDateFilter = () => {
    this.setState({ fromDateFilter: "", toDateFilter: "" }, () => this.onApplyDateFilter());
}

onGridReady = params => {
    this.gridApi = params.api;  
    //console.log("Grid is: ", params);
    this.gridColumnApi = params.columnApi;
    // Data already arrives newest-first from the backend (sorted by _id desc);
    // this just keeps the grid's own sort indicator honest about that instead
    // of pointing at "created_on", a column that was never actually named that
    // (it's "activity_date") and so silently did nothing.
    var sort = [
        {
          colId: 'activity_date',
          sort: 'desc',
        },
      ];
    this.gridApi.setSortModel(sort);
};
onGridState = () =>{
        //console.log(this.gridApi);
    
        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();
                
        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
}



closeAlert = () => {
    this.setState({
        show: false
    });
}




onClickHideAll(){
    this.setState({
    loadshow:'show-n',
    overly:'show-n',
    bulkslide:"",

    });
}

onClickDataExport(){
    if (this.state.activeTab === "sob") {
        if (this.sobTab) { this.sobTab.exportCsv(); }
        return;
    }
    if (this.gridRef && this.gridRef.current && this.gridRef.current.api) {
        this.gridRef.current.api.exportDataAsCsv({ fileName: "user_activities.csv" });
    }
}

  render() {
    
    var columnwithDefs = [    
        {
            headerName: "User Name",
            field: "username",
            width:180,
            filter: true,
            resizable: true,
            editable: false,
        },
        {
            headerName: "Staff Id",
            field: "staff_id",
            width:130,
            filter: true,
            resizable: true,
            editable: false,
        },
        {
            headerName: "Email",
            field: "email",
            width:200,
            filter: true,
            resizable: true,
            editable: false,
        },
        {
            headerName: "Company Code",
            field: "comp_code",
            width:130,
            filter: true,
            resizable: true,
            editable: false,
        },
        {
            headerName: "Department",
            field: "department",
            width:120,
            filter: true,
            resizable: true,
            editable: false,           
        },
        {
            headerName: "Role",
            field: "role",
            width:120,
            filter: true,
            resizable: true,
            editable: false,           
        },
        {
            headerName: "Screen",
            field: "screen_name",
            width:120,
            filter: true,
            resizable: true,
            editable: false,           
        },
        {
            headerName: "Activity",
            field: "activity",
            width:350,
            filter: true,
            resizable: true,
            editable: false,           
        },
        {
            headerName: "Activity Date",
            field: "activity_date",
            width:150,
            filter: true,
            resizable: true,
            editable: false,
            valueGetter:function(params){
                if(params.data.activity_date != ''){
                    return getHyphenDDMMMYYYYHHMM(params.data.activity_date);
                }
                else{
                    return "";
                }
            },   
        },
    ]

    
    return (
        <div className="container-fluid" style={{ height: "100%" }}>
            <SweetAlert
                show={this.state.show}
                type={this.state.basicType}
                title={this.state.basicTitle}
                onConfirm={this.closeAlert}
            >
            </SweetAlert>

            <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px", padding: "14px 18px", marginBottom: "10px", flexShrink: 0 }}>
                    <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                        <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                        <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>User Activities</h5>
                    </div>
                    <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "10px" }}>
                        <div className="d-flex align-items-center" style={{
                            backgroundColor: "#f4f8fd", border: "1px solid #e3edf9", borderRadius: "999px",
                            padding: "6px 14px 6px 12px", gap: "10px"
                        }}>
                            <CalendarIcon size={14} style={{ color: "#5c7a9e", flexShrink: 0 }} />
                            <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                                <span style={{ fontSize: "11px", fontWeight: 700, color: "#90a4ae", textTransform: "uppercase", letterSpacing: "0.3px" }}>From</span>
                                <input
                                    type="date"
                                    style={{ border: "none", background: "transparent", fontSize: "13px", fontWeight: 600, color: "#37474f", width: "125px", outline: "none" }}
                                    value={this.state.fromDateFilter}
                                    onChange={(e) => this.setState({ fromDateFilter: e.target.value })}
                                />
                            </div>
                            <ArrowRightIcon size={12} style={{ color: "#c7d3e0", flexShrink: 0 }} />
                            <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                                <span style={{ fontSize: "11px", fontWeight: 700, color: "#90a4ae", textTransform: "uppercase", letterSpacing: "0.3px" }}>To</span>
                                <input
                                    type="date"
                                    style={{ border: "none", background: "transparent", fontSize: "13px", fontWeight: 600, color: "#37474f", width: "125px", outline: "none" }}
                                    value={this.state.toDateFilter}
                                    onChange={(e) => this.setState({ toDateFilter: e.target.value })}
                                />
                            </div>
                            {(this.state.fromDateFilter || this.state.toDateFilter) &&
                            <span
                                onClick={this.onClearDateFilter}
                                title="Clear dates"
                                style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", color: "#90a4ae", flexShrink: 0 }}
                            >
                                <XIcon size={13} />
                            </span>
                            }
                        </div>
                        <button className="pill-btn pill-btn-info" onClick={this.onApplyDateFilter}>Apply</button>
                        <button className="pill-btn pill-btn-primary" onClick={this.onClickDataExport.bind(this)}>Export Data</button>
                    </div>
                </div>
                <div className="d-flex align-items-center" style={{ padding: "0 18px", marginBottom: "8px", gap: "8px" }}>
                    <button type="button" className={"pill-btn " + (this.state.activeTab === "activities" ? "pill-btn-info" : "pill-btn-info pill-btn-soft")}
                            onClick={() => this.setState({ activeTab: "activities" })}>Activities</button>
                    <button type="button" className={"pill-btn " + (this.state.activeTab === "sob" ? "pill-btn-info" : "pill-btn-info pill-btn-soft")}
                            onClick={() => this.setState({ activeTab: "sob" })}>SOB Runs</button>
                </div>
                {this.state.activeTab === "sob" ?
                <div className="col-xl-12 col-lg-12" style={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", minHeight: 0, paddingBottom: "12px" }}>
                    <SobRunLogTab ref={(r) => { this.sobTab = r; }} fromDate={this.state.fromDateFilter}
                                  toDate={this.state.toDateFilter} reloadKey={this.state.sobReloadKey} />
                </div>
                : <React.Fragment>
                <div className="d-flex align-items-center" style={{ padding: "0 18px", marginBottom: "8px", fontSize: "12px", color: "#78909c" }}>
                    {this.state.rowData.length < this.state.totalCount
                        ? `Showing the most recent ${this.state.rowData.length} of ${this.state.totalCount} activities - use the date filter above to narrow this down.`
                        : `Showing all ${this.state.totalCount} matching activities.`}
                </div>
                <div className="col-xl-12 col-lg-12" style={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                    <div className="ag-theme-balham grid-wrapper mb-3" style={{ flex: 1, minHeight: 0 }}>
                        <AgGridReact
                            ref={this.gridRef}
                            modules={this.state.modules}
                            columnDefs={columnwithDefs}
                            defaultColDef={{
                                sortable: true,
                                filter: true,
                                floatingFilter: true, resizable: true
                            }}
                            rowData={this.state.rowData}
                            rowHeight={45}
                            headerHeight={45}
                            enableCharts={false}
                            // autoGroupColumnDef={this.state.autoGroupColumnDef}
                            onGridReady={this.onGridReady}
                            onGridState={this.onGridState}
                            frameworkComponents={this.state.frameworkComponents}
                            statusBar={this.state.statusBar}
                            sideBar={this.state.sideBar}
                            stopEditingWhenGridLosesFocus= {true}
                            gridOptions={{
                                context: { componentParent: this }
                            }}
                            // components={this.state.components}
                            enableRangeSelection= {true}
                            // onCellEditingStopped={this.onCellUpdateData.bind(this)}
                            />
                    </div>
                </div>
                </React.Fragment>}
            </div>

            <div className={"dataLoadpage " +(this.state.loadshow)}>
            </div>
            <div className={"dataLoadpageimg " +(this.state.loadshow)}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
            <div className={"overlay-part "+(this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
        </div>
    );
  }
}


function dateComparator(date1, date2) {
	// console.log("dateComparator");
	// console.log(date1.length);
	if(date1 != "" && date2 != "" && date1 != undefined && date2 != undefined ){
		// console.log(date1,date2);
	var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
	date1 = date1.replace(date1.split(" ")[0].split("-")[1],date_1);
	var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
	date2 = date2.replace(date2.split(" ")[0].split("-")[1],date_2);
	// console.log(date1,date2);
	var date1Number = monthToComparableNumber(date1);
	var date2Number = monthToComparableNumber(date2);
	// console.log(date1Number,date2Number);
	if (date1Number === null && date2Number === null) {
	  return 0;
	}
	if (date1Number === null) {
	  return -1;
	}
	if (date2Number === null) {
	  return 1;
	}
	return date1Number - date2Number;
	}
  }
function monthToComparableNumber(date) {
	// console.log(date,date.length);
	if (date === undefined || date === null || date.length !== 16) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	console.log(yearNumber,monthNumber,dayNumber);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}

function getMonthNumber(monthName){
	var months = [
		'Jan', 'Feb', 'Mar', 'Apr', 'May',
		'Jun', 'Jul', 'Aug', 'Sep',
		'Oct', 'Nov', 'Dec'
		];
	var monthNum = months.indexOf(monthName)+1;
	if(monthNum < 10){
		monthNum = "0"+monthNum.toString();
	}
	return monthNum;
}


function loadDateTimeScript(){
	// alert("timeDate");
	$('.datetimepicker_mask').datetimepicker({
		format:'d-m-Y H:i'
	});
	$('.datetimepicker_date').datetimepicker({
		format:'d-m-Y',
		timepicker:false
	});
    var index  =window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src="https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
	//script.src="http://xdsoft.net/jqplugins/datetimepicker/"
	script.async=true
    script.defer = true
    index.parentNode.insertBefore(script,index)
}

$(document).on("change", "#toDate", function(e) {
    e.preventDefault();
    var bookingDate=$("#fromDate").val();
    var cargoDate=$("#toDate").val();
    var bookingDate = bookingDate.split("-")[2]+"-"+bookingDate.split("-")[1]+"-"+bookingDate.split("-")[0]
    var cargoDate = cargoDate.split("-")[2]+"-"+cargoDate.split("-")[1]+"-"+cargoDate.split("-")[0]

    var startDate = new Date(bookingDate);
    var endDate = new Date(cargoDate);
    var startTime = startDate.getTime();
    var endTime = endDate.getTime();
    console.log(startTime,endTime);
    if(startTime > endTime)
    {
        $("#toDate").val("");
        alert("To Date should be greater than or equal to From Date");
    }
})

$(document).on("change", "#fromDate", function(e) {
    e.preventDefault();
    var bookingDate=$("#fromDate").val();
    var cargoDate=$("#toDate").val();
    var bookingDate = bookingDate.split("-")[2]+"-"+bookingDate.split("-")[1]+"-"+bookingDate.split("-")[0]
    var cargoDate = cargoDate.split("-")[2]+"-"+cargoDate.split("-")[1]+"-"+cargoDate.split("-")[0]

    var startDate = new Date(bookingDate);
    var endDate = new Date(cargoDate);
    var startTime = startDate.getTime();
    var endTime = endDate.getTime();
    console.log(startTime,endTime);
    if(startTime > endTime)
    {
        $("#fromDate").val("");
        alert("From Date should be less than equal to To Date");
    }
})

function DateEditor () {}

// gets called once before the renderer is used
DateEditor.prototype.init = function(params) {
    // create the cell
    this.eInput = document.createElement('input');
    this.eInput.value = params.value;

    // https://jqueryui.com/datepicker/
    $(this.eInput).datetimepicker({
        dateFormat: "yy-mm-dd",
        changeMonth: true,
        changeYear: true
    });
};

// gets called once when grid ready to insert the element
DateEditor.prototype.getGui = function() {
    return this.eInput;
};

// focus and select can be done after the gui is attached
DateEditor.prototype.afterGuiAttached = function() {
    this.eInput.focus();
    this.eInput.select();
};

// returns the new value after editing
DateEditor.prototype.getValue = function() {
	// console.log(this.eInput.value);
    return this.eInput.value;
};

// any cleanup we need to be done here
DateEditor.prototype.destroy = function() {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
};

// if true, then this editor will appear in a popup
DateEditor.prototype.isPopup = function() {
    // and we could leave this method out also, false is the default
    return false;
};


